import { CORS_PROXIES, FETCH_TIMEOUT, MAX_RETRIES, RETRY_DELAY, API_HEADERS } from './constants.mjs';

export class FeedFetcher {
  static async fetchWithTimeout(url, timeout = FETCH_TIMEOUT, headers = {}) {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await fetch(url, {
        signal: controller.signal,
        headers: {
          ...API_HEADERS,
          ...headers
        }
      });
      clearTimeout(id);
      return response;
    } catch (error) {
      clearTimeout(id);
      throw error;
    }
  }

  static async fetchFeed(url) {
    for (const proxy of CORS_PROXIES) {
      let retries = 0;
      while (retries < MAX_RETRIES) {
        try {
          const proxyUrl = `${proxy}${encodeURIComponent(url)}`;
          const response = await this.fetchWithTimeout(proxyUrl);
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const text = await response.text();
          if (!text || text.trim().length === 0) {
            throw new Error('Empty response');
          }
          
          return text;
        } catch (error) {
          retries++;
          if (retries === MAX_RETRIES) break;
          await new Promise(resolve => setTimeout(resolve, RETRY_DELAY * Math.pow(2, retries)));
        }
      }
    }
    
    throw new Error(`Failed to fetch feed from ${url} after trying all proxies`);
  }
}